//https://stackoverflow.com/questions/39877156/how-to-extend-string-prototype-and-use-it-next-in-typescript/53392268

Object.defineProperties(String.prototype, {
  sqlSafe: {
    value: false,
    writable: true, // << writable
  },
})

export {}
